import { useCallback } from 'react';

import { useUserDetails } from '@/features/_shared/user';
import { captureEvent } from '@/services/analytics';
import { clock } from '@/services/clock';

type TrackingProps = {
  prompt: string;
  response: unknown[];
  conversationId: string;
  version: number;
};

export function useRateAnswerTracking({
  prompt,
  response,
  conversationId,
  version
}: TrackingProps) {
  const { userEmail } = useUserDetails();

  const track = useCallback(
    (score: number) => {
      captureEvent('ai_chat_score', {
        email: userEmail,
        prompt,
        response,
        score,
        timestamp: clock.date().toISOString(),
        thread_id: conversationId,
        version
      });
    },
    [conversationId, prompt, response, userEmail, version]
  );

  return { track } as const;
}
